
import { Component, Vue } from 'vue-property-decorator'
import RacingService from '@/biz/service/Racing/RacingService'
import RouterService from '@/service/RouterService'
import ValidateService from '@/service/ValidateService'
import FormEditor from '@/components/Form/FormEditor.vue'

@Component({
  components: {
    FormEditor
  }
})
export default class RacingForm extends Vue {
  private Service = RacingService
  private form = {
    id: RouterService.query('racing_id'),
    racing_type: 0,
    title: '',
    cover_img: '',
    city: 0,
    start_time: '',
    end_time: '',
    apply_end_time: '',
    contacts: '',
    phone: '',
    wechat: '',
    address: '',
    description: '',
    coin_sponsor: '',
    racing_id: '' as string | number,
    racing_level: 0,
    is_climbing_finals: 0,
    is_climbing: 0
  }

  private formFields = ValidateService.genRules({
    racing_type: {
      prop: 'racing_type',
      label: '赛事类型',
      tips: '可留空继承父级'
    },
    title: {
      prop: 'title',
      label: '赛事标题',
      rule: [ValidateService.required, ValidateService.max(120)]
    },
    cover_img: {
      prop: 'cover_img',
      label: '赛事封面'
    },
    city: {
      prop: 'city',
      label: '举办城市'
    },
    racing_time: {
      prop: 'racing_time',
      label: '比赛时间',
      rule: [ValidateService.required({ trigger: 'change' })]
    },
    apply_end_time: {
      prop: 'apply_end_time',
      label: '报名截止时间',
      rule: [ValidateService.required({ trigger: 'change' })]
    },
    contacts: {
      prop: 'contacts',
      label: '联系人',
      rule: [ValidateService.max(10)]
    },
    phone: {
      prop: 'phone',
      label: '手机号',
      rule: [ValidateService.mobile]
    },
    wechat: {
      prop: 'wechat',
      label: '微信号',
      rule: [ValidateService.max(20)]
    },
    coin_sponsor: {
      prop: 'coin_sponsor',
      label: '赛币冠名商',
      rule: [ValidateService.max(60)]
    },
    address: {
      prop: 'address',
      label: '报名/集合地址',
      rule: [ValidateService.max(30)]
    },
    description: {
      prop: 'description',
      label: '赛事详情'
    },
    racing_level: {
      prop: 'racing_level',
      label: '赛事级别',
      tips: '选择周赛/月赛/年赛，需同时选择父级赛事'
    },
    racing_id: {
      prop: 'racing_id',
      label: '父级赛事',
      tips: '周赛选月赛，月赛选年赛',
      props: {
        label: 'title',
        value: 'id'
      }
    },
    is_climbing: {
      prop: 'is_climbing',
      label: '是否选拔赛'
    },
    is_climbing_finals: {
      prop: 'is_climbing_finals',
      label: '是否选拔决赛'
    }
  })

  handleLoadRacingAll() {
    return RacingService.all({ page: 1, limit: 100 })
  }

  created() {
    const isAddForm = RouterService.getPath().split('/').pop() === 'form'
    if (isAddForm) {
      // 新增模式：URL 上的 racing_id 表示“父级赛事”，仅用于预选父级；
      // 绝不能作为记录自身 id，否则 FormRender 会误更新父级赛事
      this.form.id = ''
      const parentId = RouterService.query('racing_id')
      if (parentId) {
        // URL 参数是字符串, 而父级赛事下拉项的 value 是数值 id,
        // 需转成数值类型才能匹配并回显标题(否则只显示 "406")
        this.form.racing_id = Number(parentId)
      }
    } else if (!RouterService.query('id') && this.form.id) {
      // 编辑路由(racing/info)：补全 id 到 URL
      RouterService.replace('', { id: this.form.id, racing_id: this.form.id })
    }
    if (process.env.NODE_ENV === 'development') {
      this.form.racing_type = 1
      this.form.title = '赛事标题'
      this.form.cover_img = ''
      this.form.city = 440103
      this.form.start_time = '2021-04-01'
      this.form.end_time = '2021-04-30'
      this.form.apply_end_time = '2021-03-29'
      this.form.contacts = '万鑫'
      this.form.phone = '13724352543'
      this.form.wechat = 'wanxin'
      this.form.address = '报名地址'
      this.form.description = '赛事内容'
    }
  }
}
